
<template>
  <div>
  <div class="header">
    <h3 class="table-header">Ballotpedia API4</h3>
    <h3 v-on:click="logout" class="logout pull-right"><i class="vsm-icon fa fa-sign-out-alt"></i> Logout</h3>
   </div>
  </div>
</template>


<script>

export default {
  name: 'BPHeader',

  methods: {
    logout() {
		fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/logout`, {
			  method: 'POST',
			  headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			  },
			  credentials: 'include',
			  body: JSON.stringify({})
		  })
		  .then((response) => {
			  // store
			  return response.json();
		  })
		  .then((response) => {
            if ( response.success ) {
				// delete xsrf token as well
				if ( !process.env.VUE_APP_API4_DOMAIN.includes('localhost') ) {
					document.cookie = "xsrf_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Domain=.ballotpedia.org;"
				}
				else {
					document.cookie = "xsrf_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
				}
			}
		});
      this.$router.push({ path: '/login' });
    }
  }
}
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
    width: 100%;
    height: 60px;
    background: #29292D;
    position: absolute;
    top: 0;
    text-align: center;
}
.table-header {
    color: white;
    text-align: center;
    color: white;
    text-transform: uppercase;
    display: inline-block;
    margin-left: 80px; /* account for side menu */
}

.logout {
  color: white;
  font-size: 16px;
  padding-right: 30px;
  transition: .5s;
}

.logout:hover {
  cursor: pointer;
  color: #3498DB;
}
</style>
